import CourseCardImage from './CourseCardImage';
import * as types from './types';
import getCourseMetadata from './utils';

export { types, getCourseMetadata };

export default CourseCardImage;
